<template>
    <div align="center" class="w-100" direction="column">
        <v-flex
            align="center"
            class="hero mx-auto text-center flex-grow-1"
            direction="column"
            justify="center"
        >
            <h3 class="heading hero-slogan mb-3">
                Modern health &amp; wellness coaching
            </h3>
            <p class="copy hero-blurb mb-5">
                You have to do the work; you don't have to do it alone. Ladder
                pairs you with a certified digital fitness coach to match your
                personality &amp; needs.
            </p>
            <template v-if="platform.android">
                <v-button
                    :variant="variant"
                    @click.prevent="showMailingListModal = true"
                    aria-label="Ladder Android App"
                    class="hero-cta"
                    href="/"
                    size="lg"
                >
                    <fa-icon :icon="['fab', 'android']" class="mr-2" />Download
                    Ladder
                </v-button>
                <android-modal
                    :show.sync="showMailingListModal"
                    class="text-left"
                />
            </template>
            <v-button
                :variant="variant"
                aria-label="Ladder iOS App"
                class="hero-cta"
                href="https://apps.apple.com/us/app/ladder-your-personal-trainer/id1208138698?mt=8"
                size="lg"
                v-else
            >
                <fa-icon :icon="['fab', 'apple']" class="mr-3" />Download Ladder
            </v-button>
        </v-flex>
        <div class="bg-white text-dark w-100 border-bottom d-none">
            <h3 class="heading py-5">How Ladder works</h3>
            <div class="how-it-works text-left">
                <h3 class="heading text-muted">01</h3>
                <h4 class="mb-4">
                    Get paired with a certified Ladder coach based on the
                    results of your personality &amp; ability assessment
                </h4>
                <h3 class="heading text-muted">02</h3>
                <h4 class="mb-4">
                    Chat with your coach to create a personalized fitness
                    program that's right for you
                </h4>
                <h3 class="heading text-muted">03</h3>
                <h4 class="mb-0">
                    Your coach evolves your program over time adapting to
                    changes in your ability &amp; lifestyle
                </h4>
            </div>

            <div class="py-5">
                <v-button
                    @click.prevent="showMailingListModal = true"
                    aria-label="Ladder Android App"
                    href="/"
                    size="lg"
                    v-if="platform.android"
                    variant="dark"
                >
                    <fa-icon :icon="['fab', 'android']" class="mr-2" />Download
                    Ladder
                </v-button>

                <v-button
                    aria-label="Ladder iOS App"
                    href="https://apps.apple.com/us/app/ladder-your-personal-trainer/id1208138698?mt=8"
                    size="lg"
                    v-else
                    variant="dark"
                >
                    <fa-icon :icon="['fab', 'apple']" class="mr-3" />Download
                    Ladder
                </v-button>
            </div>
        </div>
        <template v-if="platform.android">
            <android-modal
                :show.sync="showMailingListModal"
                class="text-left"
            />
        </template>
    </div>
</template>

<script>
import { platform } from "@/utils/platform";
import AndroidModal from "@/components/AndroidModal";
import anime from "animejs/lib/anime.es.js";

export default {
    name: "IndexLandingView",
    components: {
        AndroidModal
    },
    data() {
        return {
            platform,
            variant: "outline-warning",
            showAppLinkModal: false,
            showMailingListModal: false
        };
    },
    mounted() {
        anime.timeline().add({
            targets: ".hero-slogan, .hero-blurb, .hero-cta",
            opacity: [0, 1],
            translateZ: [0],
            translateY: [40, 0],
            duration: 600,
            delay: anime.stagger(300),
            easing: "easeOutQuad"
        });
    }
};
</script>

<style lang="scss" scoped>
.how-it-works {
    max-width: 50%;
}
.hero {
    max-width: 50%;
    height: calc(100vh - 4.75rem);
}
.heading {
    font-size: 2.8rem;
}
.copy {
    font-size: 1.25rem;
    color: rgba(255, 255, 255, 0.5);
}
@media (max-width: #{map-get($grid-breakpoints, "md")}) {
    .hero {
        padding: 1rem;
        max-width: 100%;
    }
    .how-it-works {
        max-width: 90%;
    }
}
</style>
